export enum PIP_EVENT_PLAYER_DOWNLOAD_KEYS {
  ROAD = 'road',
  DUAL = 'dual',
  ALL = 'all',
}
